// public
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import base from './ButtonShell.css';
import { mergeStyles } from '@xingternal/merge-styles';

const ButtonShell = ({
  innerRef,
  disabled = false,
  children,
  icon: Icon,
  loading,
  to,
  href,
  skin,
  ...props
}) => {
  const styles = mergeStyles(base, skin);
  let Tag = 'button';
  if (to) {
    Tag = Link;
  } else if (href) {
    Tag = 'a';
  }
  return (
    <Tag
      to={to}
      href={href}
      ref={innerRef}
      className={styles.button}
      disabled={disabled || loading}
      {...props}
    >
      <div className={base.inner}>
        {!loading && Icon && <Icon className={styles.buttonIcon} />}
        {loading && (
          <div className={styles.buttonLoading}>
            <span className={styles.buttonLoadingDot} />
            <span className={styles.buttonLoadingDot} />
            <span className={styles.buttonLoadingDot} />
          </div>
        )}
        {!loading && children}
      </div>
    </Tag>
  );
};

export default ButtonShell;

ButtonShell.propTypes = {
  /** @ignore */
  skin: PropTypes.object,
  /** label of the button, should be text, icons are handled separately */
  children: PropTypes.node,
  /** @callback */
  onClick: PropTypes.func,
  /** if you want to grab the DOM node */
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  /** You can hand over an Icon component here */
  icon: PropTypes.func,
  /** show the loading state of the button, yes/no */
  loading: PropTypes.bool,
  /** greyed and not clickable, yes/no */
  disabled: PropTypes.bool,
  /** triggers the rendering of a router Link instead of a button */
  to: PropTypes.string,
  /** triggers the rendering of an <a> instead of a button */
  href: PropTypes.string,
};
